import { render, staticRenderFns } from "./CollectionHome.vue?vue&type=template&id=07de6572"
import script from "./CollectionHome.vue?vue&type=script&lang=ts"
export * from "./CollectionHome.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports